import { X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useNotificationContext } from '../../contexts/NotificationContext';

const ICONS: Record<string, string> = {
  TICKET_ASSIGNED: '🎫',
  NEW_MESSAGE: '💬',
  INTERNAL_NOTE: '🔒',
  STATUS_CHANGED: '🔄',
};

export function NotificationToastStack() {
  const { toasts, dismissToast, markRead } = useNotificationContext();
  const navigate = useNavigate();

  if (toasts.length === 0) return null;

  return (
    <div className="notification-toast-stack" aria-live="polite">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="notification-toast"
          role="button"
          tabIndex={0}
          onClick={() => {
            if (!toast.read) {
              void markRead(toast.id);
            }
            dismissToast(toast.id);
            if (toast.ticketId) {
              navigate(`/tickets/${toast.ticketId}`);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (!toast.read) {
                void markRead(toast.id);
              }
              dismissToast(toast.id);
              if (toast.ticketId) {
                navigate(`/tickets/${toast.ticketId}`);
              }
            }
          }}
        >
          <span className="notification-toast-icon" aria-hidden>
            {ICONS[toast.type] ?? '🔔'}
          </span>
          <div className="notification-toast-body">
            <div className="notification-toast-title">{toast.title}</div>
            <div className="notification-toast-text">{toast.body}</div>
          </div>
          <button
            type="button"
            className="notification-toast-close"
            onClick={(e) => {
              e.stopPropagation();
              dismissToast(toast.id);
            }}
            aria-label="Dismiss notification"
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
